// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~web/react/components/common/styles/colors.css\"","color-black":"#000000","colorBlack":"#000000","selectedCountry":"_3E13p _1R_Wx"};